import React from 'react';

import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

import WidgetCapacity from 'src/features/statistic/components/WidgetCapacity';
import { statisticMessages } from 'src/features/statistic/utils/messages';
import { useTitleStore } from 'src/stores/useTitleStore';

export default function CapacityStatistics() {
    const { formatMessage } = useIntl();
    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(statisticMessages.capacityOverview));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <div className="flex gap-6">
            <WidgetCapacity date={dayjs()} />
            <WidgetCapacity date={dayjs().subtract(1, 'day')} />
        </div>
    );
}
